// Lezen van een Server-Sent Events-stream (`data: {...}\n\n`, afgesloten met
// `data: [DONE]`). De browser-API EventSource kan alleen GET zonder headers,
// terwijl de chat-endpoints een POST met CSRF-header zijn — vandaar met de hand.

export class SseError extends Error {}

export async function readSse(response: Response, onEvent: (data: any) => void): Promise<void> {
  if (!response.ok || !response.body) throw new SseError(`HTTP ${response.status}`);

  const reader = response.body.getReader();
  const decoder = new TextDecoder();
  let buffer = "";
  let done = false;

  while (!done) {
    const chunk = await reader.read();
    done = chunk.done;
    buffer += decoder.decode(chunk.value || new Uint8Array(), { stream: !done });

    const events = buffer.split("\n\n");
    buffer = events.pop() || ""; // laatste stuk kan half zijn

    for (const event of events) {
      const line = event.split("\n").find((candidate) => candidate.startsWith("data: "));
      if (!line) continue;
      const payload = line.slice(6).trim();
      if (payload === "[DONE]") return;

      let data: any;
      try {
        data = JSON.parse(payload);
      } catch {
        throw new SseError("invalid-stream-event");
      }
      if (data.error) throw new SseError(data.error);
      onEvent(data);
    }
  }
}
